import SimpleCrypto from 'simple-crypto-js';
import localStorageService from 'src/views/auth/localStorageService';

/*
 * ---------------------------------------------------------------------------
 * BACKEND CONNECTION
 * ---------------------------------------------------------------------------
 * Automatic na ito -- hindi na kailangang mag-comment/uncomment ng URL.
 *
 *   yarn start   -> NODE_ENV = "development"  -> TEST server
 *   yarn build   -> NODE_ENV = "production"   -> PRODUCTION server
 *
 * Kung gusto mong ituro sa ibang backend (hal. localhost), gumawa ng .env
 * sa root at ilagay ang REACT_APP_API_URL / REACT_APP_SERVER_API.
 * Tingnan ang .env.example. I-restart ang `yarn start` pagkatapos.
 */
const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const ENDPOINTS = {
  production: {
    URL: 'https://adminapi.leon-gallery.com/api',
    serverApi: 'https://app.leon-gallery.com',
  },
  test: {
    URL: 'http://157.230.43.47:3000/api',
    serverApi: 'http://157.230.43.47:8080',
  },
};

const active = IS_PRODUCTION ? ENDPOINTS.production : ENDPOINTS.test;
const API_URL = process.env.REACT_APP_API_URL || active.URL;
const SERVER_API = process.env.REACT_APP_SERVER_API || active.serverApi;

if (!IS_PRODUCTION) {
  console.log('[Api] environment:', process.env.NODE_ENV, '| API_URL:', API_URL);
}

/*
 * ---------------------------------------------------------------------------
 * SESSION
 * ---------------------------------------------------------------------------
 * BABALA: hindi ito totoong encryption.
 *
 * Naka-hardcode ang susi sa ibaba, at nasa frontend ang code na ito -- kaya
 * napupunta ang susi sa JS bundle na ipinapadala sa BAWAT browser. Sinuman
 * ang magbukas ng DevTools ay makakabasa nito at ma-de-decrypt ang session.
 *
 * At HINDI ito naaayos sa pamamagitan ng .env. Ang REACT_APP_* na variable ay
 * pinapalitan ng aktwal na halaga ni Create React App habang nagbi-build --
 * napupunta rin sa bundle. Walang paraan para magtago ng sikreto sa frontend.
 *
 * Obfuscation lang ito, hindi seguridad. Ang totoong proteksyon ay nasa
 * backend: dapat i-validate ng server ang token sa bawat request, at huwag
 * magtiwala sa kahit anong galing sa localStorage.
 */
const SESSION_KEY = 'some-unique-key';
const simpleCrypto = new SimpleCrypto(SESSION_KEY);

/**
 * Binabasa ang session sa localStorage.
 *
 * MAHALAGA: function ito, hindi module-level constant.
 * Dati, isang beses lang binabasa ang localStorage -- sa import time.
 * Kaya pagkatapos mag-login, `undefined` pa rin ang laman hangga't hindi
 * nag-fu-full page reload. Gumagana lang iyon ngayon dahil naka-
 * `window.location.href` ang login. Masisira agad kapag ginawang
 * client-side navigation. Basa-sa-tuwing-tatawagin na ito.
 */
function readSession() {
  const empty = { superAdmin: undefined, userID: undefined, username: undefined, groupName: undefined };

  const authUser = localStorageService.getItem('auth_user');
  if (!authUser) return empty;

  try {
    // Baligtad ang mga pangalan ng field (diresu = userid, emanresu = username,
    // nekton = token, atbp.). Obfuscation ito ng dating dev.
    return {
      superAdmin: simpleCrypto.decrypt(authUser.nropID),
      userID: simpleCrypto.decrypt(authUser.diresu),
      username: simpleCrypto.decrypt(authUser.emanresu),
      groupName: simpleCrypto.decrypt(authUser.namegroup),
    };
  } catch (error) {
    // Dati, blangko ang catch na ito -- naka-comment lahat. Kaya kapag sira
    // ang session data, tahimik na bumabagsak ang app at walang makikita
    // ang user o ang dev kung bakit.
    console.error('[Api] Hindi mabasa ang session. Mag-login ulit.', error);
    return empty;
  }
}

const session = readSession();

const Api = {
  request: {
    URL: API_URL,
    serverApi: SERVER_API,

    superAdmin: session.superAdmin,
    userID: session.userID,
    username: session.username,
    groupName: session.groupName,
    jobTitle: session.groupName,
  },

  // Ginagamit sa 55 file bilang background color.
  background: {
    theme: '#c0c0c0',
  },

  // Kulay ng header ng table.
  table: {
    head: '#3e4396',
  },
};

// Para sa bagong code: gamitin ito para laging sariwa ang session,
// sa halip na Api.request.userID na basa noong import time pa.
export const getSession = readSession;

export default Api;